export const targetAudiencesAgeRatings = {
  CHILDREN: {
    minAge: 0,
    maxAge: 10,
  },
  TEENAGER: {
    minAge: 11,
    maxAge: 17,
  },
  ADULT: {
    minAge: 18,
    maxAge: 60,
  },
  ELDERLY: {
    minAge: 0,
    maxAge: 18,
  },
};

export const ageRatingByTargetAudience = {
  KIDS: ['L', 'AL', '6', 'A6'],
  CHILDREN: ['L', 'AL', '6', 'A6', '10', 'A10'],
  TEENAGER: [
    'L',
    'AL',
    '6',
    'A6',
    '10',
    'A10',
    '12',
    'A12',
    '14',
    'A14',
    '16',
    'A16',
  ],
  ADULT: [
    'L',
    'AL',
    '6',
    'A6',
    '10',
    'A10',
    '12',
    'A12',
    '14',
    'A14',
    '16',
    'A16',
    '18',
    'A18',
  ],
  ELDERLY: [
    'L',
    'AL',
    'A6',
    '6',
    '10',
    'A10',
    '12',
    'A12',
    '14',
    'A14',
    '16',
    'A16',
    '18',
    'A18',
  ],
};

export const targetAudiencesLabel = {
  KIDS: 'Infantil',
  CHILDREN: 'Infantil - Adolescente',
  TEENAGER: 'Adolescente',
  ADULT: 'Adulto',
  ELDERLY: 'Idoso',
};

export const targetAudiencesKeys = {
  KIDS: 'KIDS',
  CHILDREN: 'CHILDREN',
  TEENAGER: 'TEENAGER',
  ADULT: 'ADULT',
  ELDERLY: 'ELDERLY',
};

export const targetAudiencesRadioLabel = {
  [targetAudiencesKeys.KIDS]: 'Infantil - até 6 anos',
  [targetAudiencesKeys.CHILDREN]: 'Infantil - de 6 a 10 anos',
  [targetAudiencesKeys.TEENAGER]: 'Adolescente - de 11 a 17 anos',
  [targetAudiencesKeys.ADULT]: 'Adulto - de 18 a 60 anos',
  [targetAudiencesKeys.ELDERLY]: 'Idoso - acima de 60 anos',
};
